import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import FontAwesome from '@/libs/fontawesome'
import Icon from '@/libs/iconify'

createApp(App)
  .use(store)
  .use(router)
  .component('fa', FontAwesome)
  .component('icon', Icon)
  .mount('#app')
